/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedAllocationBreakdownDtoSchema = z.object({
  description: z.optional(z.string()),
  amount: z.optional(z.string()),
  percent: z.optional(z.string()),
});
